import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Autentisering feilet");
        navigate("/login");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for user data
        const response = await fetch(
          "https://demobackend.emergentagent.com/auth/v1/env/oauth/session-data",
          {
            method: "GET",
            mode: "cors",
            headers: {
              "X-Session-ID": sessionId,
              "Accept": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Session data error:", response.status, errorText);
          throw new Error("Kunne ikke hente brukerdata");
        }

        const userData = await response.json();

        // Send to our backend to create/update user and session
        const backendResponse = await fetch(`${API}/auth/google`, {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify({
            email: userData.email,
            name: userData.name,
            picture: userData.picture,
            google_id: userData.id,
            session_token: userData.session_token,
          }),
        });

        if (!backendResponse.ok) {
          const errorText = await backendResponse.text();
          console.error("Backend auth error:", backendResponse.status, errorText);
          throw new Error("Kunne ikke opprette bruker");
        }

        const result = await backendResponse.json();

        // Login with the user data
        loginWithGoogle(
          {
            id: result.id,
            name: result.name,
            email: result.email,
            picture: result.picture,
          },
          result.token
        );

        toast.success(`Velkommen, ${result.name}!`);
        
        // Clean URL and navigate to home
        window.history.replaceState({}, document.title, "/");
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Google auth error:", error);
        toast.error(error.message || "Noe gikk galt under innlogging");
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, loginWithGoogle]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Logger inn med Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
